// extracted by mini-css-extract-plugin
export default {"accordionContainer":"regular-user-settings_accordionContainer__dteuh","profileImg":"regular-user-settings_profileImg__jrCUD"};